import { api } from "../client";
import {
  PlaceExtraFields,
  PlaceFields,
  PartialPlaceExtraFields,
  PartialPlaceFields,
} from "../schema/Place";
import { Config, ConfigMutate } from "../types";

type ApiRequestConfig = Config<PlaceFields, PlaceExtraFields>;
type ApiRequestConfigMutate = ConfigMutate<
  PartialPlaceFields,
  PartialPlaceExtraFields
>;

export const getPlaces = async (config?: ApiRequestConfig) => {
  return api.get<PlaceFields, PlaceExtraFields>("places", config);
};
export const getPlace = (id: number, config?: ApiRequestConfig) => {
  return api.get<PlaceFields, PlaceExtraFields>(`places/${id}`, config);
};

export const createPlace = (config: ApiRequestConfigMutate) => {
  return api.create<PartialPlaceFields, PartialPlaceExtraFields>(
    "places",
    config
  );
};
export const updatePlace = (id: number, config?: ApiRequestConfigMutate) => {
  return api.update<PartialPlaceFields, PartialPlaceExtraFields>(
    `places/${id}`,
    config
  );
};
export const deletePlace = (id: number) => {
  return api.remove<PlaceFields, PlaceExtraFields>(`places/${id}`);
};
